var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-group"},[_c('date-picker',{attrs:{"date":_vm.startTime,"option":_vm.option},on:{"change":_vm.dateUpdated}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }